// @TODO <HEALTH2019>
App.filter('healthInsuranceWithPaymentsTypeFilter', function () {
    var dictionary = {
        REHABILITATION: 'Rehabilitacja',
        VIP: 'Kompleksowy Złoty VIP',
        FULL: 'Kompleksowy Złoty',
        EXPANDED: 'Rozszerzony Złoty',
        BASIC: 'Podstawowy',
        SENIOR: 'Senior'
    };

    return function (el) {
        if(!el){
            return el;
        }

        return dictionary[el] || el;
    };
});
// @TODO </HEALTH2019>
